interface ToastProps {
  message: string;
  show: boolean;
}

function Toast({
  message,
  show,
}: ToastProps) {
  if (!show) return null;

  return (
    <div className="toast">
      {message}
    </div>
  );
}

export default Toast;